export default defineNuxtRouteMiddleware((to, from) => {
  if (useState('keepDialogs').value) {
    useState('keepDialogs').value = false
    return
  }

  if (to.path !== from.path) closeDialogs({ closedReason: 'navigation' })
})
